import React, { useMemo,useState, useEffect } from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { topNav, subNavMap } from "./navConfig";
import TopHeader from "../components/layout/TopHeader";
import DynamicSubHeader from "../components/layout/DynamicSubHeader";
import FooterBar from "../components/layout/FooterBar";
import "../styles/artistic-ui.css";
import axiosConfig from "../AxiosConfig";
export default function AppShell({ setIsAuth }) {
  const [activityMenu, setActivityMenu] = useState([]);

const user = JSON.parse(
  localStorage.getItem("userData")
);

useEffect(() => {
  getProductionSteps();
}, []);

const getProductionSteps = async () => {
  try {
    const res = await axiosConfig.get(
      `/production-step/view-steps/${user?._id}`
    );
    const menu = (
      res?.data?.steps?.[0]?.steps || []
    ).map((item) => ({
      label: item.step_Name,
      key: item.step_Name
        ?.toLowerCase()
        ?.replace(/\s+/g, "-"),
    }));

    setActivityMenu(menu);

    console.log(menu);
  } catch (err) {
    console.log(err);
  }
};
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // 🔥 Active Top Menu
  const activeTop = useMemo(() => {
    const found = topNav.find((item) =>
      item.path === "/"
        ? location.pathname === "/"
        : location.pathname.startsWith(item.path)
    );
    return found?.key || "dashboard";
  }, [location.pathname]);

  // 🔥 Sub Menu List
  // const validSubs = subNavMap[activeTop] || [];
const validSubs =
  activeTop === "activity"
    ? activityMenu
    : subNavMap[activeTop] || [];
  // 🔥 Current View (query param)
  const requestedSub = searchParams.get("view");

  // 🔥 FIXED MATCHING (IMPORTANT)
// const activeSubObj = useMemo(() => {
//   return validSubs.find((item) =>
//     requestedSub?.includes(item.key)
//   );
// }, [requestedSub, validSubs]);
const activeSubObj = useMemo(() => {
  return (
    validSubs.find(
      (item) => item.key === requestedSub
    ) || validSubs[0]
  );
}, [requestedSub, validSubs]);
const activeSub = activeSubObj?.key;

  // 🔥 Change Sub Menu
  const setActiveSub = (nextSub) => {
    const next = new URLSearchParams(searchParams);
    next.set("view", nextSub);
    setSearchParams(next);
  };

  return (
    <div className="erp-root">
      <div className="erp-shell">

        {/* 🔥 Top Header */}
        <TopHeader setIsAuth={setIsAuth} activeTop={activeTop} activeSub={activeSub} />

        {/* 🔥 Sub Header */}
        <DynamicSubHeader
          activeTop={activeTop}
          activeSub={activeSub}
          setActiveSub={setActiveSub}
          validSubs={validSubs}
        />

        {/* 🔥 Main Content */}
        <main className="erp-main-shell">
          <Outlet context={{ activeTop, activeSub }} />
        </main>

        {/* 🔥 Footer */}
        <FooterBar />
      </div>
    </div>
  );
}